module.exports = __webpack_public_path__ + "media/images/add-note-14c91d47df090ee977ae9cfbecc73836.png";